<template>
  <div class="content-dashboard" v-bind="$attrs">
    <div v-if="mode === 'vue-caclul-home'">
      <div class="d-flex align-items-center justify-content-between">
        <h3>Calcul de ration</h3>

        <a href="#" class="btn btn-orange" @click="mode = 'vue-data-calcul'"> Faire un calcul</a>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="search-block">
            <div class="position-relative">
              <input
                type="text"
                class="form-control"
                id="search"
                v-model="form.search"
                placeholder="Rechercher un propriétaire (nom, prénom, email, téléphone)..."
              />
              <div class="search-btn">
                <i class="ti ti-search"></i>
              </div>
              <button
                v-if="form.search"
                @click="form.search = ''"
                class="btn btn-link position-absolute"
                style="right: 45px; top: 50%; transform: translateY(-50%); padding: 0; color: #6c757d"
                type="button"
                title="Effacer la recherche"
              >
                <i class="ti ti-x"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-center mt-4">
        <h3>Liste des calculs par propriétaire</h3>

        <a
          href="#"
          class="link orange-color"
          data-bs-toggle="modal"
          data-bs-target="#ProprietereAddModal"
          @click="openAddModal"
        >
          <img :src="addPersonSmall" />
          <span class="ps-2 text-decoration-underline">Ajouter un propriétaire</span>
        </a>
      </div>

      <!-- État de chargement -->
      <div v-if="listingLoading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status"></div>
        <p class="mt-3">Chargement des calculs de ration...</p>
      </div>

      <!-- Erreur de chargement -->
      <div v-else-if="listingError" class="alert alert-danger mt-4">
        <h5>Erreur de chargement</h5>
        <p>{{ listingError }}</p>
        <button @click="loadGroupedRations()" class="btn btn-outline-orange btn-sm">
          <i class="ti ti-refresh"></i> Réessayer
        </button>
      </div>

      <div v-else-if="groupedRations.owners.length === 0" class="alert alert-info mt-4">
        <h5>Aucun calcul de ration trouvé</h5>
        <p>Il n'y a actuellement aucun calcul de ration enregistré.</p>
      </div>

      <div v-if="form.search && filteredOwners.length > 0" class="alert alert-info mt-3">
        <i class="ti ti-info-circle me-2"></i>
        {{ searchResultsCount }} résultat{{ searchResultsCount > 1 ? "s" : "" }} trouvé{{
          searchResultsCount > 1 ? "s" : ""
        }}
        pour "{{ form.search }}"
        <button @click="form.search = ''" class="btn btn-link btn-sm p-0 ms-2 text-decoration-underline">
          Afficher tous les propriétaires
        </button>
      </div>

      <div v-if="form.search && filteredOwners.length === 0" class="alert alert-warning mt-4">
        <h5>Aucun résultat trouvé</h5>
        <p>Aucun propriétaire ne correspond à votre recherche "{{ form.search }}".</p>
        <button @click="form.search = ''" class="btn btn-outline-orange btn-sm">
          <i class="ti ti-x"></i> Effacer la recherche
        </button>
      </div>

      <div v-if="filteredOwners.length > 0" class="accordion accordion-block mt-3" id="accordionExample">
        <div v-for="(owner, index) in filteredOwners" :key="owner.owner.id" class="accordion-item" style="border: 1px solid #aeb1ba !important">
          <h4 class="accordion-header" :id="'heading' + index" @click="toggleSection(index)">
            <div class="d-flex justify-content-between w-100">
              <div>
                <span class="accordion-title">{{ getOwnerDisplayName(owner.owner) }}</span>
              </div>
              <div class="d-flex gap-2 align-items-center">
                <button class="btn btn-outline-orange" @click.stop="deleteOwner(owner.owner)">
                  <span>
                    <img :src="deleteIcon" />
                  </span>
                  Supprimer le propriétaire
                </button>

                <i :class="['ti', activeIndex === index ? 'ti-angle-up' : 'ti-angle-down', 'transition']"></i>
              </div>
            </div>
          </h4>

          <div class="accordion-collapse collapse" :class="{ show: activeIndex === index }">
            <div class="accordion-body">
              <!-- Affichage des rations pour ce propriétaire -->
              <div v-if="owner.rations && owner.rations.length > 0">
                <CalculAccordion
                  v-for="ration in owner.rations"
                  :key="ration.id"
                  :ration="ration"
                  @reminder="handleRationReminder"
                  @download-pdf="handleRationDownloadPdf"
                  @edit="handleRationEdit"
                  @delete="handleRationDelete"
                  class="mb-3"
                />
              </div>
              <div v-else class="alert alert-info">Aucune ration calculée pour ce propriétaire.</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="mode === 'vue-data-calcul'">
      <div class="d-flex gap-2 align-items-center">
        <span class="back-link cursor-pointer" @click="mode = 'vue-caclul-home'"
          ><i class="ti ti-back-left font-20 orange-color pe-2"></i
        ></span>
        <div>
          <h3>Calcul de ration</h3>
        </div>
      </div>

      <div class="d-flex justify-content-center step-cart mt-5">
        <div class="col-lg-12">
          <div class="d-flex gap-3 align-items-center py-4 step-cart-centent step-block">
            <div
              class="step-number step"
              :class="{ active: currentStep === 1, completed: currentStep > 1 }"
              @click="goToStep(1)"
            >
              <span class="badge mx-2">
                <i v-if="currentStep > 1" class="ti ti-check"></i>
                <span v-else>1</span>
              </span>
              <span class="step-title">Données de calcul</span>
            </div>
            <div class="separator"></div>

            <div
              class="step-number step"
              :class="{ active: currentStep === 2, completed: currentStep > 2 }"
              @click="goToStep(2)"
            >
              <span class="badge mx-2">
                <i v-if="currentStep > 2" class="ti ti-check"></i>
                <span v-else>2</span>
              </span>
              <span class="step-title">Informations détaillées</span>
            </div>
            <div class="separator"></div>

            <div class="step-number step" :class="{ active: currentStep === 3 }" @click="goToStep(3)">
              <span class="badge mx-2">3</span>
              <span class="step-title">Résultats</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="currentStep === 1">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-9">
            <form class="mt-5">
              <div class="d-flex gap-4 mb-4">
                <div class="input-form flex-fill">
                  <label class="label-control"> Date de visite*</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="formData.step1.dateVisite"
                    :class="{ 'is-invalid': stepErrors.step1.dateVisite }"
                    required
                  />
                  <div v-if="stepErrors.step1.dateVisite" class="invalid-feedback">
                    {{ stepErrors.step1.dateVisite }}
                  </div>
                </div>

                <div class="input-form flex-fill">
                  <label class="label-control"> Prochaine visite</label>
                  <input type="date" class="form-control" v-model="formData.step1.prochaineVisite" />
                </div>
              </div>

              <div class="d-flex gap-4">
                <div class="input-form flex-fill">
                  <div class="form-input">
                    <label class="label-control"> Propriétaire* </label>

                    <div class="d-flex gap-2 align-items-center">
                      <select
                        class="form-select calcul-ration-select flex-grow-1"
                        v-model="selectedProprietaireId"
                        @change="onProprietaireChange"
                        :class="{ 'is-invalid': stepErrors.step1.proprietaireId }"
                      >
                        <option value="" selected>Sélectionner un propriétaire</option>
                        <option v-for="owner in formattedProprietaires" :key="owner.id" :value="owner.id">
                          {{ owner.fullName }}
                        </option>
                      </select>
                      <img
                        :src="addPersonSmall"
                        class="cursor-pointer"
                        data-bs-toggle="modal"
                        data-bs-target="#ProprietereAddModal"
                        @click="openAddModal"
                      />
                    </div>
                    <div v-if="stepErrors.step1.proprietaireId" class="invalid-feedback">
                      {{ stepErrors.step1.proprietaireId }}
                    </div>
                  </div>
                </div>

                <div class="input-form flex-fill">
                  <div class="form-input">
                    <label class="label-control"> Animal*</label>

                    <div v-if="shouldShowAddAnimalButton" class="w-100">
                      <button
                        type="button"
                        class="btn btn-outline-orange w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                        @click="emitOpenAddAnimal"
                      >
                        <img :src="addanimal" class="w-20" />
                        <span>Ajouter un animal pour ce propriétaire</span>
                      </button>
                    </div>

                    <div v-else class="d-flex gap-2 align-items-center">
                      <select
                        class="form-select calcul-ration-select flex-grow-1"
                        v-model="selectedAnimalId"
                        :disabled="!selectedProprietaireId || animauxStore.loading"
                        :class="{ 'is-invalid': stepErrors.step1.animalId }"
                      >
                        <option value="" disabled selected>
                          {{
                            animauxStore.loading
                              ? "Chargement des animaux..."
                              : !selectedProprietaireId
                                ? "Sélectionner d'abord un propriétaire"
                                : "Sélectionner un animal"
                          }}
                        </option>
                        <option v-for="animal in availableAnimaux" :key="animal.id" :value="animal.id">
                          {{ animal.name }}
                        </option>
                      </select>

                      <div
                        v-if="selectedAnimalId"
                        class="cursor-pointer edit-animal-icon"
                        @click="emitOpenEditAnimal"
                        title="Modifier l'animal"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 18.5 18.5"
                          fill="none"
                        >
                          <g transform="translate(-3.25 -2.25)">
                            <path
                              d="M16.475,5.408l2.117,2.117m-.756-3.982L12.109,9.27a2.118,2.118,0,0,0-.579,1.082L11,13l2.648-.53a2.118,2.118,0,0,0,1.082-.579l5.727-5.727a1.854,1.854,0,0,0-2.621-2.621Z"
                              stroke="#ff8c00"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.5"
                            />
                            <path
                              d="M19,15v3a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V7A2,2,0,0,1,6,5H9"
                              stroke="#ff8c00"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.5"
                            />
                          </g>
                        </svg>
                      </div>

                      <img
                        :src="addanimal"
                        class="w-10 cursor-pointer"
                        :class="{ 'opacity-50': !selectedProprietaireId }"
                        @click="emitOpenAddAnimal"
                      />
                    </div>
                    <div v-if="stepErrors.step1.animalId" class="invalid-feedback">
                      {{ stepErrors.step1.animalId }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-center">
                <button type="button" class="btn btn-orange w-25" @click="nextStep">Confirmer</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div v-if="currentStep === 2">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-9">
            <form class="mt-5" @submit.prevent>
              <div class="row">
                <div class="col-lg-12 mb-5">
                  <label class="form-label">Référence*</label>

                  <div
                    v-if="productsStore.isRationLoading"
                    class="d-flex align-items-center justify-content-center py-3"
                  >
                    <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                    <span>Chargement des produits...</span>
                  </div>

                  <div v-else-if="!productsStore.hasRationProducts" class="alert alert-info">
                    {{
                      formData.step1.animalObject?.animalTypeId
                        ? "Aucun produit disponible pour ce type d'animal"
                        : "Sélectionnez d'abord un animal à l'étape 1"
                    }}
                    <div class="mt-2">
                      <small class="text-muted">Debug: Products count: {{ productsStore.rationProducts.length }}</small>
                    </div>
                  </div>

                  <div v-else class="product-selector">
                    <div class="position-relative">
                      <div
                        class="form-control d-flex justify-content-between align-items-center"
                        @click="toggleProductDropdown"
                        style="cursor: pointer; min-height: 60px"
                      >
                        <div class="d-flex gap-3 align-items-center">
                          <img
                            :src="getProductImage(productsStore.selectedRationProduct)"
                            alt="img"
                            v-if="getProductImage(productsStore.selectedRationProduct)"
                            style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px"
                          />
                          <div v-if="productsStore.selectedRationProduct">
                            <div class="fw-bold">{{ productsStore.selectedRationProduct.name }}</div>
                            <div class="text-muted small">{{ productsStore.selectedRationProduct.gamme }}</div>
                          </div>
                          <span v-else class="text-muted">Sélectionner un produit</span>
                        </div>
                        <i
                          class="ti ti-angle-down"
                          :class="{ 'rotate-180': showProductDropdown }"
                          style="transition: transform 0.2s"
                        ></i>
                      </div>

                      <div
                        v-show="showProductDropdown"
                        class="position-absolute w-100 bg-white border rounded shadow-lg"
                        style="top: 100%; z-index: 1050; max-height: 300px; overflow-y: auto"
                      >
                        <div
                          v-for="product in productsStore.availableRationProducts"
                          :key="product.id"
                          class="p-3 border-bottom hover-bg-light d-flex gap-3 align-items-center"
                          style="cursor: pointer"
                          @click="selectProduct(product)"
                        >
                          <img
                            :src="getProductImage(product)"
                            alt="img"
                            style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px"
                            v-if="getProductImage(product)"
                          />
                          <div>
                            <div class="fw-bold">{{ product.name }}</div>
                            <div class="text-muted small">{{ product.gamme_supplyvet || '' }}</div>
                          </div>
                        </div>
                        <div
                          v-if="productsStore.availableRationProducts.length === 0"
                          class="p-3 text-center text-muted"
                        >
                          Aucun produit disponible
                        </div>
                      </div>
                    </div>

                    <div v-if="productsStore.selectedRationProduct" class="mt-3">
                      <label class="form-label">Variant*</label>
                      <select
                        class="form-select"
                        :value="productsStore.selectedRationVariant?.code || ''"
                        @change="selectVariant($event.target.value)"
                        :class="{ 'is-invalid': stepErrors.step2.reference }"
                      >
                        <option value="" disabled>Sélectionner un variant</option>
                        <option
                          v-for="variant in productsStore.availableRationVariants"
                          :key="variant.code"
                          :value="variant.code"
                          :disabled="!variant.inStock && !(variant.datePrecommandeSupplyvetEsupplyvet && new Date(variant.datePrecommandeSupplyvetEsupplyvet) > new Date())"
                        >
                          {{ variant.name }}
                          {{ (!variant.inStock && !(variant.datePrecommandeSupplyvetEsupplyvet && new Date(variant.datePrecommandeSupplyvetEsupplyvet) > new Date())) ? " (Rupture de stock)" : "" }}
                        </option>
                      </select>
                      <div v-if="stepErrors.step2.reference" class="invalid-feedback">
                        {{ stepErrors.step2.reference }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="adaptive-inputs-grid">
                  <div class="form-input adaptive-input-item">
                    <label class="label-control">{{ getTargetWeightLabel() }}</label>
                    <div class="input-group" style="border: unset !important">
                      <input
                        type="number"
                        class="form-control"
                        v-model="formData.step2.targetWeightValue"
                        step="0.1"
                        min="0"
                        placeholder="Ex: 24.0"
                        :class="{ 'is-invalid': stepErrors.step2.targetWeight }"
                      />
                      <span class="input-group-text">Kg</span>
                    </div>
                    <div v-if="stepErrors.step2.targetWeight" class="invalid-feedback d-block">
                      {{ stepErrors.step2.targetWeight }}
                    </div>
                    <small class="text-muted">Modifiable pour ajuster le calcul</small>
                  </div>

                  <!-- Activité quotidienne (conditionnel) -->
                  <div class="form-input adaptive-input-item" v-if="shouldShowActivityInputs">
                    <label class="label-control">Activité quotidienne* </label>
                    <select
                      class="form-select"
                      v-model="selectedDailyActivityId"
                      :class="{ 'is-invalid': stepErrors.step2.activiteQuotidienne }"
                    >
                      <option value="" disabled>Sélectionner une activité</option>
                      <option v-for="act in animauxStore.dailyActivities" :key="act.id" :value="act.id">
                        {{ act.name }}
                      </option>
                    </select>
                    <div v-if="stepErrors.step2.activiteQuotidienne" class="invalid-feedback">
                      {{ stepErrors.step2.activiteQuotidienne }}
                    </div>
                  </div>

                  <!-- Stade physiologique (conditionnel) -->
                  <div class="form-input adaptive-input-item" v-if="shouldShowActivityInputs">
                    <label class="label-control">Stade physiologique* </label>
                    <select
                      class="form-select"
                      v-model="selectedPhysiologicalStageId"
                      :class="{ 'is-invalid': stepErrors.step2.stadePhysiologique }"
                    >
                      <option value="" disabled>Sélectionner un stade</option>
                      <option v-for="st in animauxStore.physiologicalStages" :key="st.id" :value="st.id">
                        {{ st.name }}
                      </option>
                    </select>
                    <div v-if="stepErrors.step2.stadePhysiologique" class="invalid-feedback">
                      {{ stepErrors.step2.stadePhysiologique }}
                    </div>
                  </div>

                  <div class="form-input adaptive-input-item" v-if="shouldShowWeightManagementInput">
                    <label class="label-control">Gestion de surpoids*</label>
                    <select
                      class="form-select"
                      v-model="selectedWeightManagementId"
                      :class="{ 'is-invalid': stepErrors.step2.gestionSurpoids }"
                    >
                      <option value="" disabled>Sélectionner une option</option>
                      <option
                        v-for="wm in animauxStore.getFilteredWeightManagements(
                          formData.step1.animalObject?.animalTypeId
                        )"
                        :key="wm.id"
                        :value="wm.id"
                      >
                        {{ wm.name }}
                      </option>
                    </select>
                    <div v-if="stepErrors.step2.gestionSurpoids" class="invalid-feedback">
                      {{ stepErrors.step2.gestionSurpoids }}
                    </div>
                    <small class="text-muted">Obligatoire pour les produits d'obésité</small>
                  </div>

                  <div class="form-input adaptive-input-item">
                    <label class="label-control">Tarif TTC</label>
                    <input
                      type="text"
                      class="form-control"
                      :value="productsStore.formattedTarifTtc || 'Sélectionner un variant'"
                      disabled
                      readonly
                      placeholder="Prix TTC"
                    />
                    <small v-if="productsStore.isPriceLoading" class="text-muted">
                      <i class="ti ti-loader me-1"></i>Chargement du prix...
                    </small>
                    <small v-else-if="!productsStore.selectedRationVariant" class="text-muted">
                      Sélectionnez d'abord un variant
                    </small>
                  </div>
                </div>

                <div v-if="calculationNote" class="alert alert-info mt-3 mb-4" role="alert">
                  <i class="ti ti-info-circle me-2"></i>
                  <strong>Note :</strong> {{ calculationNote }}
                </div>

                <div class="col-lg-6">
                  <div class="d-flex align-items-center mb-4">
                    <label> Afficher le cout journalier sur le pdf</label>
                    <div class="form-check form-switch">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="switch1" v-model="isChecked" />
                      </div>
                    </div>
                  </div>
                  <div class="form-input">
                    <label class="label-control"> Rappel à J-7 ? </label>

                    <div class="d-flex align-items-center gap-3">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="reminderEmail"
                          value="email"
                          v-model="reminderJ7Types"
                        />
                        <label class="form-check-label" for="reminderEmail"> Email </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="reminderSMS"
                          value="sms"
                          v-model="reminderJ7Types"
                        />
                        <label class="form-check-label" for="reminderSMS"> SMS </label>
                      </div>
                    </div>
                  </div>

                  <div v-if="hasRemindersSelected" class="form-input">
                    <label class="label-control">Mise en place de l'aliment*</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="formData.step2.applicationStartDate"
                      :class="{ 'is-invalid': stepErrors.step2.applicationStartDate }"
                      required
                    />
                    <div v-if="stepErrors.step2.applicationStartDate" class="invalid-feedback">
                      {{ stepErrors.step2.applicationStartDate }}
                    </div>
                  </div>
                </div>

                <div class="col-lg-8">
                  <h3>Adresses de la clinique</h3>

                  <div v-if="veterinaryAddresses.length === 0" class="alert alert-info mt-3">
                    Aucune adresse de livraison disponible
                  </div>

                  <div v-for="address in veterinaryAddresses" :key="address.id" class="radio-group mt-3 mb-3">
                    <label class="radio-option">
                      <input
                        type="radio"
                        name="clinicAddress"
                        :value="address.id"
                        v-model="selectedClinicAddress"
                        :class="{ 'is-invalid': stepErrors.step2.adresseClinique }"
                      />
                      <div class="radio-content">
                        <div class="radio-title">
                          {{ address.firstName }} {{ address.lastName }} - {{ address.street }}, {{ address.postcode }}
                          {{ address.city }}
                        </div>
                      </div>
                    </label>
                  </div>

                  <div v-if="stepErrors.step2.adresseClinique" class="invalid-feedback d-block">
                    {{ stepErrors.step2.adresseClinique }}
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-start mt-5">
                <button class="btn btn-outline-orange me-2 w-25" @click="prevStep">
                  <i class="ti ti-angle-left"></i> Précédente
                </button>
                <button class="btn btn-orange w-25" @click="nextStep">Suivant</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div v-if="currentStep === 3">
        <div v-if="calculationError" class="alert alert-danger mb-4">
          <h5>Erreur de calcul</h5>
          <p>{{ calculationError }}</p>
          <button @click="prevStep()" class="btn btn-outline-orange btn-sm">
            <i class="ti ti-angle-left"></i> Retour pour corriger
          </button>
        </div>

        <div v-if="calculationLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-3">Calcul de la ration en cours...</p>
        </div>

        <div v-else class="box-chart mt-5 mb-5">
          <div class="d-flex justify-content-between gap-3">
            <div class="d-flex gap-3 align-items-center">
              <img :src="animalImage" class="round-15" />

              <div>
                <span class="d-block blue-color">{{ animalType }}</span>
                <strong class="d-block blue-color">{{ animalName }}</strong>
                <p>
                  <span v-for="(line, index) in fullAnimalDescription" :key="index" class="d-block">
                    {{ line }}
                  </span>
                </p>
              </div>
            </div>

            <div>
              <div class="gray-box result-box">
                <div class="mb-4">
                  <p v-if="dailyRation">
                    Ration journalière : <strong>{{ dailyRation }}</strong>
                  </p>
                  <p v-if="dailyCost">
                    Coût journalier : <strong>{{ dailyCost }}</strong>
                  </p>
                  <p v-if="bagDuration">
                    Durée du sac : <strong>{{ bagDuration }}</strong>
                  </p>
                </div>
                <div class="d-flex justify-content-center flex-column">
                  <a @click="prevStep" class="btn btn-outline-orange font-bold mb-4">Recalculer</a>
                  <a @click="downloadPDF()" class="btn btn-outline-orange font-bold">
                    <i class="ti ti-download"></i> Télécharger
                  </a>
                </div>
              </div>
              <p>
                <i>
                  Servir progressivement l'aliment en ménageant une transition de quelques jours avec l'alimentation
                  précédente
                </i>
              </p>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center mt-5">
          <button class="btn btn-outline-orange me-2 w-25" @click="prevStep">
            <i class="ti ti-angle-left"></i> Précédente
          </button>
          <button class="btn btn-orange w-25" @click="submitFinalForm" :disabled="saveLoading">
            <span v-if="saveLoading"> <i class="ti ti-loader"></i> Enregistrement... </span>
            <span v-else>Enregistrer</span>
          </button>
        </div>

        <div v-if="saveSuccess" class="alert alert-success mt-4">Calcul sauvegardé avec succès !</div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="ProprietereAddModal" ref="ProprietereAddModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-width">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button type="button" class="close-link" data-bs-dismiss="modal">
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal">
          <div class="title-modal">
            <img :src="addPersonLarge" />
            <h3>Ajouter un propriétaire</h3>
          </div>

          <form class="mt-4">
            <div class="row justify-content-center align-items-center">
              <div class="col-lg-9">
                <div class="d-flex gap-3 mb-4">
                  <div class="input-form">
                    <label class="label-control"> Nom*</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="proprietaireForm.lastName"
                      :class="{ 'is-invalid': formErrors.lastName }"
                      required
                    />
                    <div v-if="formErrors.lastName" class="invalid-feedback">
                      {{ formErrors.lastName }}
                    </div>
                  </div>
                  <div class="input-form">
                    <label class="label-control">Prénom*</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="proprietaireForm.firstName"
                      :class="{ 'is-invalid': formErrors.firstName }"
                      required
                    />
                    <div v-if="formErrors.firstName" class="invalid-feedback">
                      {{ formErrors.firstName }}
                    </div>
                  </div>
                </div>

                <div class="d-flex gap-3">
                  <div class="input-form">
                    <label class="label-control"> E-mail*</label>
                    <input
                      type="email"
                      class="form-control"
                      v-model="proprietaireForm.email"
                      :class="{ 'is-invalid': formErrors.email }"
                      required
                    />
                    <div v-if="formErrors.email" class="invalid-feedback">
                      {{ formErrors.email }}
                    </div>
                  </div>
                  <div class="input-form">
                    <label class="label-control">Téléphone portable</label>
                    <div class="input-group">
                      <select
                        class="form-select telephone-select"
                        v-model="proprietaireForm.indicatifCellphone"
                      >
                        <option
                          v-for="country in countryDialCodes"
                          :key="country.code"
                          :value="country.dialCode"
                        >
                          {{ country.displayCode }} {{ country.code }}
                        </option>
                      </select>
                      <input
                        type="tel"
                        class="form-control telephone-input"
                        v-model="proprietaireForm.cellphone"
                        v-only-digits
                        :class="{ 'is-invalid': formErrors.cellphone }"
                      />
                    </div>
                    <div v-if="formErrors.cellphone" class="invalid-feedback">
                      {{ formErrors.cellphone }}
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-center gap-3 mt-3">
                  <button type="button" class="btn btn-outline-orange w-25" data-bs-dismiss="modal" @click="closeModal">
                    Annuler
                  </button>
                  <button
                    type="button"
                    class="btn btn-orange w-25"
                    @click="submitProprietaire"
                    :disabled="proprietairesStore.loading"
                  >
                    <span v-if="proprietairesStore.loading"> <i class="ti ti-loader"></i> Ajout... </span>
                    <span v-else>Valider</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="SuccessModal" ref="SuccessModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button type="button" class="close-link" data-bs-dismiss="modal" style="display: none">
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-header justify-content-center">
          <h5 class="modal-title text-success">
            <i class="ti ti-check-circle me-2"></i>
            Succès
          </h5>
        </div>
        <div class="modal-body text-center">
          <p class="mb-0">Calcul de ration enregistré avec succès !</p>
        </div>
        <div class="modal-footer justify-content-center gap-3">
          <button class="btn btn-outline-orange" @click="downloadPDF()">
            <i class="ti ti-download me-2"></i>
            Télécharger le PDF
          </button>
          <button class="btn btn-orange" @click="returnToListing()">Retour au listing</button>
        </div>
      </div>
    </div>
  </div>
  <AnimalAddModal />
  <AnimalEditModal />
  <RationReminderModal ref="reminderModal" @saved="onReminderSaved" />
</template>

<script>
  import CalculAccordion from "@/components/CalculAccordion.vue";
  import addanimal from "@/assets/images/animal-add.svg";
  import chien1 from "@/assets/images/chien1.jpg";
  import chat1 from "@/assets/images/chat1.png";
  import addPersonSmall from "@/assets/icons/add-person-small.svg";
  import addPersonLarge from "@/assets/icons/add-person-large.svg";
  import editIcon from "@/assets/icons/edit.svg";
  import deleteIcon from "@/assets/icons/delete.svg";
  import { useProprietairesStore } from "@/stores/esupplyvet/proprietairesStore";
  import { useAnimauxStore } from "@/stores/animauxStore";
  import { useAuthStore } from "@/stores/authStore";
  import { useProductsStore } from "@/stores/productsStore";
  import { getAddresses } from "@/api/services/esupplyvet/addressesService";
  import { calculRationService } from "@/api/services/calculRationService";
  import { JsPdfService } from "@/services/pdf/jsPdfService";
  import { COUNTRIES } from "@/config/constants";
  import { getCountryCallingCode } from "libphonenumber-js";
  import AnimalAddModal from "@/components/supplyvet/AnimalAddModal.vue";
  import AnimalEditModal from "@/components/supplyvet/AnimalEditModal.vue";
  import RationReminderModal from "@/components/supplyvet/RationReminderModal.vue";
  import emitter from "@/event-bus";
  import VeterinaryTokenService from "@/services/veterinaryTokenService";

  export default {
    name: "CalculRationView",
    inheritAttrs: false,
    components: {
      CalculAccordion,
      AnimalAddModal,
      AnimalEditModal,
      RationReminderModal,
    },
    data() {
      return {
        jsPdfService: new JsPdfService(),
        form: {
          search: "",
        },
        proprietaireForm: {
          firstName: "",
          lastName: "",
          email: "",
          cellphone: "",
          indicatifCellphone: "33",
        },
        formErrors: {},
        animalForm: {
          name: "",
          animalTypeId: "",
          raceId: "",
          birthDate: "",
          gender: "",
          proprietaireId: "",
          weight: 0.0,
          dailyActivityId: "",
          physiologicalStageId: "",
          idealWeight: 0.0,
          underAge: false,
        },
        animalFormErrors: {},
        filteredRaces: [],
        filteredDailyActivities: [],
        filteredPhysiologicalStages: [],
        editAnimalForm: {
          id: null,
          name: "",
          animalTypeId: "",
          raceId: "",
          birthDate: "",
          gender: "",
          proprietaireId: "",
          weight: 0.0,
          dailyActivityId: "",
          physiologicalStageId: "",
          idealWeight: 0.0,
          underAge: false,
        },
        editAnimalFormErrors: {},
        editFilteredRaces: [],
        editFilteredDailyActivities: [],
        editFilteredPhysiologicalStages: [],
        selectedProprietaireId: "",
        selectedAnimalId: "",
        selectedPhysiologicalStageId: "",
        selectedDailyActivityId: "",
        selectedWeightManagementId: "",
        selectedClinicAddress: "",
        veterinaryAddresses: [],
        idealWeight: 0.0,
        currentStep: 1,
        hasVisitedStep2: false,
        step1SnapshotAtStep2: null,
        showProductDropdown: false,
        activeIndex: null,
        sections: [],
        mode: "vue-caclul-home",
        groupedRations: {
          totalItems: 0,
          owners: [],
        },
        listingLoading: false,
        listingError: null,
        stepValidation: {
          step1: false,
          step2: false,
          step3: false,
        },
        stepErrors: {
          step1: {},
          step2: {},
          step3: {},
        },
        formData: {
          step1: {
            dateVisite: "",
            prochaineVisite: "",
            proprietaireId: "",
            animalId: "",
            proprietaireObject: null,
            animalObject: null,
          },
          step2: {
            reference: null,
            poidsIdeal: 0,
            activiteQuotidienne: "",
            stadePhysiologique: "",
            tarifTTC: "",
            adresseClinique: null,
            afficherCout: false,
            rappelJ7: "",
            targetWeightValue: "",
            applicationStartDate: "",
          },
        },
        isChecked: false,
        reminderJ7Types: [],
        calculationResults: null,
        calculationLoading: false,
        calculationError: null,
        calculationNote: null,
        saveLoading: false,
        addanimal,
        chien1,
        chat1,
        addPersonSmall,
        addPersonLarge,
        editIcon,
        deleteIcon,
      };
    },
    computed: {
      proprietairesStore() {
        return useProprietairesStore();
      },
      animauxStore() {
        return useAnimauxStore();
      },
      authStore() {
        return useAuthStore();
      },
      productsStore() {
        return useProductsStore();
      },
      formattedProprietaires() {
        return this.proprietairesStore.formattedProprietaires;
      },
      countryDialCodes() {
        return COUNTRIES.map((country) => {
          try {
            const dialCode = getCountryCallingCode(country.code);
            return {
              ...country,
              dialCode: dialCode,
              displayCode: `+${dialCode}`,
              displayName: `${country.name} (+${dialCode})`,
            };
          } catch (error) {
            return null;
          }
        })
        .filter((c) => c)
        .sort((a, b) => a.name.localeCompare(b.name));
      },
      availableAnimaux() {
        return this.animauxStore.animaux || [];
      },
      shouldShowAddAnimalButton() {
        return this.selectedProprietaireId && !this.animauxStore.loading && this.availableAnimaux.length === 0;
      },
      selectedAnimalObject() {
        if (!this.selectedAnimalId) return null;
        return this.availableAnimaux.find(animal => animal.id === parseInt(this.selectedAnimalId));
      },
      animalType() {
        return this.formData.step1.animalObject?.species?.toUpperCase() || "";
      },

      animalName() {
        return this.formData.step1.animalObject?.name || "Nom de l'animal";
      },

      isUnderAgeSelected() {
        return !!this.formData.step1.animalObject?.underAge;
      },

      fullAnimalDescription() {
        const results = this.calculationResults;
        const animal = this.formData.step1.animalObject;

        if (!results) return [];

        const lines = [];
        lines.push(`Référence: ${this.getProductReference()}`);
        const isUnderAge = animal?.underAge;
        const weightValue = isUnderAge ? results.estimatedAdultWeight : results.idealWeight;
        if (weightValue) {
          lines.push(`Poids idéal: ${weightValue} Kg`);
        }

        if (results.dailyActivityName) {
          lines.push(`Activité quotidienne: ${results.dailyActivityName}`);
        }

        if (results.physiologicalStageName) {
          lines.push(`Stade physiologique: ${results.physiologicalStageName}`);
        }

        if (results.weightManagementName) {
          lines.push(`Gestion du surpoids: ${results.weightManagementName}`);
        }
        return lines;
      },

      dailyRation() {
        if (this.calculationResults?.recommendedDailyAmount) {
          return `${Math.round(parseFloat(this.calculationResults.recommendedDailyAmount))}g`;
        }
        return "";
      },

      dailyCost() {
        if (this.calculationResults?.showDailyExpenses && this.calculationResults?.dailyExpenses) {
          const costInEuros = parseFloat(this.calculationResults.dailyExpenses);
          if (!isNaN(costInEuros)) {
            return `${costInEuros.toFixed(2)} €`;
          }
        }
        return "";
      },

      bagDuration() {
        if (this.calculationResults?.consumptionDurationDays) {
          return `${this.calculationResults.consumptionDurationDays} jours`;
        }

        if (this.calculationResults?.recommendedDailyAmount && this.calculationResults?.variantWeight) {
          const dailyAmountKg = parseFloat(this.calculationResults.recommendedDailyAmount) / 1000;
          const productWeightKg = parseFloat(this.calculationResults.variantWeight) / 1000;
          const duration = Math.round(productWeightKg / dailyAmountKg);
          return `${duration} jours`;
        }

        return "";
      },

      saveSuccess() {
        return this.$data.saveSuccessFlag || false;
      },

      isPuppyKittenProduct() {
        const selectedProduct = this.productsStore.selectedRationProduct;
        if (!selectedProduct || !selectedProduct.tagProduit) return false;
        return selectedProduct.tagProduit.includes("chiot") || selectedProduct.tagProduit.includes("chaton");
      },

      isObesityProduct() {
        const selectedProduct = this.productsStore.selectedRationProduct;
        if (!selectedProduct || !selectedProduct.tagProduit) return false;
        return selectedProduct.tagProduit.includes("obesite");
      },

      shouldShowActivityInputs() {
        return !this.isUnderAgeSelected && !this.isPuppyKittenProduct;
      },

      shouldShowWeightManagementInput() {
        return this.isObesityProduct;
      },

      pdfFilename() {
        const animal = this.formData.step1.animalObject;
        const date = new Date().toISOString().split("T")[0];
        return `ration-${animal?.name || "animal"}-${date}.pdf`;
      },
      filteredOwners() {
        if (!this.form.search || this.form.search.trim() === "") {
          return this.groupedRations.owners;
        }

        const searchTerm = this.form.search.toLowerCase().trim();

        return this.groupedRations.owners.filter(ownerGroup => {
          const owner = ownerGroup.owner;
          const searchableText = [
            owner.firstName || "",
            owner.lastName || "",
            owner.email || "",
            owner.cellphone || "",
          ]
            .join(" ")
            .toLowerCase();

          return searchableText.includes(searchTerm);
        });
      },

      searchResultsCount() {
        return this.filteredOwners.length;
      },
      hasRemindersSelected() {
        return this.reminderJ7Types.length > 0;
      },

      animalImage() {
        const animal = this.formData.step1.animalObject;
        if (!animal?.animalTypeId) return this.chien1;

        const animalType = this.animauxStore.animalTypes.find(t => t.id === parseInt(animal.animalTypeId));
        if (!animalType) return this.chien1;

        const slug = String(animalType.slug || "").toLowerCase();
        const name = String(animalType.name || "").toLowerCase();

        if (slug === "cat" || name === "chat") {
          return this.chat1;
        }

        return this.chien1; // Par défaut pour chien et autres
      },
    },
    async mounted() {
      await this.loadGroupedRations();
      await Promise.all([
        this.proprietairesStore.fetchProprietaires(),
        this.animauxStore.fetchAnimalTypes(),
        this.animauxStore.fetchAnimalRaces(),
        this.fetchVeterinaryAddresses(),
      ]);
      emitter.on("animal:created", this.onAnimalCreated);
      emitter.on("animal:updated", this.onAnimalUpdated);
    },
    beforeUnmount() {
      emitter.off("animal:created", this.onAnimalCreated);
      emitter.off("animal:updated", this.onAnimalUpdated);
      this.cleanupVeterinaryTokenSystem();
    },
    beforeRouteLeave(to, from, next) {
      this.cleanupVeterinaryTokenSystem();
      next();
    },
    watch: {
      selectedAnimalId(newAnimalId) {
        this.formData.step1.animalId = newAnimalId;

        if (newAnimalId) {
          this.formData.step1.animalObject = this.getAnimalObject(newAnimalId);
          if (this.formData.step1.animalObject?.animalTypeId) {
            this.fetchSpecificitiesByType();
            this.loadProductsForAnimalType();
          }
        } else {
          this.formData.step1.animalObject = null;
          this.productsStore.resetRationState();
        }
        this.maybeResetStep2OnStep1Change();
      },

      selectedProprietaireId(newProprietaireId) {
        this.formData.step1.proprietaireId = newProprietaireId;
        if (newProprietaireId) {
          this.formData.step1.proprietaireObject = this.getProprietaireObject(newProprietaireId);
        } else {
          this.formData.step1.proprietaireObject = null;
        }
        this.maybeResetStep2OnStep1Change();
      },
      reminderJ7Types: {
        handler(newVal) {
          if (newVal.length === 0) {
            this.formData.step2.applicationStartDate = "";
          }
        },
        deep: true,
      },

      'formData.step1.dateVisite'() {
        this.maybeResetStep2OnStep1Change();
      },

      'formData.step1.prochaineVisite'() {
        this.maybeResetStep2OnStep1Change();
      },

      selectedDailyActivityId: {
        handler(newVal, oldVal) {
          if (newVal !== oldVal && newVal) {
            this.triggerCalculation();
          }
        }
      },

      selectedPhysiologicalStageId: {
        handler(newVal, oldVal) {
          if (newVal !== oldVal && newVal) {
            this.triggerCalculation();
          }
        }
      },

      selectedWeightManagementId: {
        handler(newVal, oldVal) {
          if (newVal !== oldVal && newVal) {
            this.triggerCalculation();
          }
        }
      },
    },
    methods: {
      forceVeterinaryContextForDelegates() {
        try {
          VeterinaryTokenService.forceActivateVeterinaryContext();
        } catch (error) {
          console.error('[CalculRationView] Erreur activation forcée contexte:', error);
        }
      },
      cleanupVeterinaryTokenSystem() {
        try {
          VeterinaryTokenService.cleanup();
        } catch (error) {
          console.error('[CalculRationView] Erreur nettoyage système JWT:', error);
        }
      },

      emitOpenAddAnimal() {
        emitter.emit("animal:add:open");
      },
      emitOpenEditAnimal() {
        if (this.selectedAnimalId) {
          emitter.emit("animal:edit:open", { animalId: parseInt(this.selectedAnimalId) });
        }
      },
      onAnimalCreated(newAnimal) {
        try {
          const ownerId = newAnimal?.ownerId || newAnimal?.owner?.id || this.selectedProprietaireId;
          if (ownerId) {
            this.selectedProprietaireId = ownerId.toString();
            this.animauxStore.fetchAnimauxByProprietaire(ownerId).catch(() => {});
          }
          if (newAnimal?.id) {
            this.selectedAnimalId = newAnimal.id.toString();
          }
        } catch (e) {
          console.warn("onAnimalCreated handler error:", e);
        }
      },

      onAnimalUpdated(updatedAnimal) {
        try {
          const ownerId = updatedAnimal?.ownerId || updatedAnimal?.owner?.id || this.selectedProprietaireId;
          if (ownerId) {
            this.animauxStore.fetchAnimauxByProprietaire(ownerId).catch(() => {});
          }
          if (updatedAnimal?.id) {
            this.selectedAnimalId = updatedAnimal.id.toString();
          }
        } catch (e) {
          console.warn("onAnimalUpdated handler error:", e);
        }
      },

      goToStep(step) {
        if (step <= this.currentStep || this.canProceedToStep(step)) {
          if (step === 2) {
            this.hasVisitedStep2 = true;
            this.captureStep1Snapshot();
          }
          this.currentStep = step;
        }
      },

      canProceedToStep(step) {
        if (step === 1) return true;
        if (step === 2) return this.stepValidation.step1;
        if (step === 3) return this.stepValidation.step1 && this.stepValidation.step2;
        return false;
      },

      getProprietaireObject(proprietaireId) {
        return this.proprietairesStore.proprietaires.find(p => p.id === parseInt(proprietaireId)) || null;
      },

      getAnimalObject(animalId) {
        return this.animauxStore.animaux.find(a => a.id === parseInt(animalId)) || null;
      },

      async validateStep1() {
        const errors = {};
        if (!this.formData.step1.dateVisite) {
          errors.dateVisite = "La date de visite est obligatoire";
        }

        if (!this.formData.step1.proprietaireId) {
          errors.proprietaireId = "Le propriétaire est obligatoire";
        }

        if (!this.formData.step1.animalId) {
          errors.animalId = "L'animal est obligatoire";
        }

        this.stepErrors.step1 = errors;

        if (Object.keys(errors).length === 0) {
          this.formData.step1.proprietaireObject = this.getProprietaireObject(this.formData.step1.proprietaireId);
          this.formData.step1.animalObject = this.getAnimalObject(this.formData.step1.animalId);

          this.stepValidation.step1 = true;
          return true;
        }

        this.stepValidation.step1 = false;
        return false;
      },

      validateStep2() {
        const errors = {};
        if (!this.formData.step2.reference) {
          errors.reference = "La référence est obligatoire";
        }
        if (!this.selectedClinicAddress) {
          errors.adresseClinique = "L'adresse de la clinique est obligatoire";
        }

        const underAge = !!this.formData.step1.animalObject?.underAge;
        const weightVal = this.formData.step2.targetWeightValue;
        if (!weightVal || isNaN(parseFloat(weightVal)) || parseFloat(weightVal) <= 0) {
          errors.targetWeight = underAge ? "Le poids adulte estimé est obligatoire" : "Le poids idéal est obligatoire";
        }
        if (this.shouldShowActivityInputs) {
          if (!this.selectedDailyActivityId) {
            errors.activiteQuotidienne = "L'activité quotidienne est obligatoire";
          }
          if (!this.selectedPhysiologicalStageId) {
            errors.stadePhysiologique = "Le stade physiologique est obligatoire";
          }
        }
        if (this.shouldShowWeightManagementInput && !this.selectedWeightManagementId) {
          errors.gestionSurpoids = "La gestion de surpoids est obligatoire pour les produits d'obésité";
        }
        if (this.hasRemindersSelected && !this.formData.step2.applicationStartDate) {
          errors.applicationStartDate = "La date de mise en place de l'aliment est obligatoire";
        }

        this.stepErrors.step2 = errors;

        if (Object.keys(errors).length === 0) {
          this.stepValidation.step2 = true;
          return true;
        }

        this.stepValidation.step2 = false;
        return false;
      },

      collectAllFormData() {
        const selectedVariant = this.productsStore.selectedRationVariant;
        const isUnderAge = !!this.formData.step1.animalObject?.underAge;
        const normalized = this.normalizeWeight(this.formData.step2.targetWeightValue);

        const base = {
          animalId: parseInt(this.formData.step1.animalId),
          productVariantId: selectedVariant ? parseInt(selectedVariant.id) : null,
          visite: this.formData.step1.dateVisite,
          nextVisite: this.formData.step1.prochaineVisite || null,
          showDailyExpenses: this.isChecked,
          reminderJ7Type: this.reminderJ7Types, // ['sms', 'email']
          veterinarianAddressIds: [parseInt(this.selectedClinicAddress)], // [15] - tableau avec une seule valeur
        };

        if (normalized) {
          if (isUnderAge) {
            base.estimatedAdultWeight = normalized;
            base.idealWeight = null;
          } else {
            base.idealWeight = normalized;
            base.estimatedAdultWeight = null;
          }
        }

        if (!isUnderAge) {
          base.dailyActivityId = this.selectedDailyActivityId ? parseInt(this.selectedDailyActivityId) : null;
          base.physiologicalStageId = this.selectedPhysiologicalStageId
            ? parseInt(this.selectedPhysiologicalStageId)
            : null;
          base.weightManagementId = this.selectedWeightManagementId ? parseInt(this.selectedWeightManagementId) : null;
        } else {
          base.dailyActivityId = null;
          base.physiologicalStageId = null;
          base.weightManagementId = null;
        }
        if (this.productsStore.selectedVariantTarifTtc) {
          base.tarifTtc = this.productsStore.selectedVariantTarifTtc;
        }
        if (this.hasRemindersSelected && this.formData.step2.applicationStartDate) {
          base.applicationStartDate = this.formData.step2.applicationStartDate;
        }

        return base;
      },

      syncFormData() {
        this.formData.step1.proprietaireId = this.selectedProprietaireId;
        this.formData.step1.animalId = this.selectedAnimalId;
        this.formData.step2.reference = this.productsStore.getRationReferenceObject();
        this.formData.step2.poidsIdeal = this.idealWeight;
        this.formData.step2.activiteQuotidienne = this.selectedDailyActivityId;
        this.formData.step2.stadePhysiologique = this.selectedPhysiologicalStageId;
        this.formData.step2.adresseClinique = this.selectedClinicAddress;
        this.formData.step2.afficherCout = this.isChecked;

        if (!this.formData.step2.targetWeightValue) {
          const initial = this.getInitialTargetWeightFromAnimal();
          if (initial) {
            this.formData.step2.targetWeightValue = initial;
          }
        }
      },

      autoSelectPhysiologicalStage() {
        if (!this.formData.step1.animalObject?.animalTypeId) {
          return;
        }

        const autoLoadStage = this.animauxStore.getAutoLoadPhysiologicalStage(
          this.formData.step1.animalObject.animalTypeId
        );
        if (autoLoadStage && !this.selectedPhysiologicalStageId) {
          this.selectedPhysiologicalStageId = autoLoadStage.id;
        }
      },

      async fetchSpecificitiesByType() {
        const typeId = this.formData.step1.animalObject?.animalTypeId;
        if (!typeId) return;
        try {
          await Promise.all([
            this.animauxStore.fetchDailyActivities(typeId),
            this.animauxStore.fetchPhysiologicalStages(typeId),
            this.animauxStore.fetchWeightManagements(typeId),
          ]);
        } catch (error) {
          console.error("Erreur chargement spécificités:", error);
        }
      },

      initSpecificitiesForStep2() {
        const animal = this.formData.step1.animalObject;
        if (!animal) return;

        if (animal.underAge) {
          this.selectedDailyActivityId = "";
          this.selectedPhysiologicalStageId = "";
          return;
        }

        if (!this.selectedDailyActivityId && animal.dailyActivityId) {
          this.selectedDailyActivityId = animal.dailyActivityId.toString();
        }

        if (!this.selectedPhysiologicalStageId) {
          if (animal.physiologicalStageId) {
            this.selectedPhysiologicalStageId = animal.physiologicalStageId.toString();
          } else {
            const auto = this.animauxStore.getAutoLoadPhysiologicalStage(animal.animalTypeId);
            if (auto?.id) {
              this.selectedPhysiologicalStageId = auto.id.toString();
            }
          }
        }
      },
      async nextStep() {
        this.syncFormData();

        if (this.currentStep === 1) {
          const isValid = await this.validateStep1();
          if (isValid && this.currentStep < 3) {
            this.currentStep++;
            this.hasVisitedStep2 = true;
            this.captureStep1Snapshot();
            this.$nextTick(async () => {
              await this.loadProductsForAnimalType();
              await this.fetchSpecificitiesByType();
              this.initSpecificitiesForStep2();
              this.autoSelectPhysiologicalStage();
            });
          }
        } else if (this.currentStep === 2) {
          const isValid = this.validateStep2();
          if (isValid) {
            await this.calculateRation();
            if (!this.calculationError) {
              this.currentStep++;
            }
          }
        } else if (this.currentStep === 3) {
          await this.submitFinalForm();
        }
      },

      prevStep() {
        if (this.currentStep > 1) {
          this.currentStep--;
        }
      },

      async triggerCalculation() {
        if (this.canTriggerCalculation()) {
          await this.calculateRation();
        }
      },

      canTriggerCalculation() {
        return this.formData.step1.animalId &&
               this.productsStore.selectedRationProduct &&
               this.productsStore.selectedRationVariant &&
               (this.selectedDailyActivityId || this.selectedPhysiologicalStageId || this.selectedWeightManagementId);
      },

      async calculateRation() {
        try {
          this.calculationLoading = true;
          this.calculationError = null;

          const finalData = this.collectAllFormData();
          const result = await calculRationService.calculateRation(finalData);
          this.calculationResults = result;
          this.calculationNote = result?.calculationNotes || null;
        } catch (error) {
          console.error("Erreur lors du calcul:", error);
          this.calculationError = "Erreur lors du calcul de ration. Veuillez vérifier vos données.";
          this.calculationNote = null;
        } finally {
          this.calculationLoading = false;
        }
      },

      async submitFinalForm() {
        try {
          this.saveLoading = true;
          const isUnderAge = !!this.formData.step1.animalObject?.underAge;
          const normalized = this.normalizeWeight(this.formData.step2.targetWeightValue);

          const saveData = {
            visite: this.formData.step1.dateVisite,
            nextVisite: this.formData.step1.prochaineVisite || null,
            showDailyExpenses: this.isChecked,
            reminderJ7Type: this.reminderJ7Types,
            animalId: parseInt(this.formData.step1.animalId),
            productVariantId: this.productsStore.selectedRationVariant
              ? parseInt(this.productsStore.selectedRationVariant.id)
              : 0,
            veterinarianAddressIds: [this.selectedClinicAddress],
          };

          if (normalized) {
            if (isUnderAge) {
              saveData.estimatedAdultWeight = normalized;
              saveData.idealWeight = null;
            } else {
              saveData.idealWeight = normalized;
              saveData.estimatedAdultWeight = null;
            }
          }

          if (!isUnderAge) {
            saveData.dailyActivityId = this.selectedDailyActivityId ? parseInt(this.selectedDailyActivityId) : null;
            saveData.physiologicalStageId = this.selectedPhysiologicalStageId
              ? parseInt(this.selectedPhysiologicalStageId)
              : null;
            saveData.weightManagementId = this.selectedWeightManagementId
              ? parseInt(this.selectedWeightManagementId)
              : null;
          } else {
            saveData.dailyActivityId = null;
            saveData.physiologicalStageId = null;
            saveData.weightManagementId = null;
          }

          if (this.productsStore.selectedVariantTarifTtc) {
            saveData.tarifTtc = this.productsStore.selectedVariantTarifTtc;
          }

          if (this.hasRemindersSelected && this.formData.step2.applicationStartDate) {
            saveData.applicationStartDate = this.formData.step2.applicationStartDate;
          }

          await calculRationService.saveRation(saveData);

          this.showSuccessModal();

          await this.loadGroupedRations();
        } catch (error) {
          console.error("Erreur lors de l'enregistrement:", error);
          alert("Erreur lors de l'enregistrement du calcul");
        } finally {
          this.saveLoading = false;
        }
      },

      showSuccessModal() {
        this.$nextTick(() => {
          const modal = this.$refs.SuccessModal;
          if (modal) {
            const button = document.createElement("button");
            button.setAttribute("data-bs-toggle", "modal");
            button.setAttribute("data-bs-target", "#SuccessModal");
            button.style.display = "none";
            document.body.appendChild(button);
            button.click();
            document.body.removeChild(button);
          }
        });
      },

      returnToListing() {
        const modal = this.$refs.SuccessModal;
        if (modal) {
          const closeButton = modal.querySelector('[data-bs-dismiss="modal"]');
          if (closeButton) {
            closeButton.click();
          }
        }
        this.mode = "vue-caclul-home";
        this.resetFormForNewCalculation();
      },

      closeSuccessModal() {
        const modal = this.$refs.SuccessModal;
        if (modal) {
          const closeButton = modal.querySelector('[data-bs-dismiss="modal"]');
          if (closeButton) {
            closeButton.click();
          }
        }
      },

      resetFormForNewCalculation() {
        this.currentStep = 1;
        this.stepValidation = {
          step1: false,
          step2: false,
          step3: false,
        };
        this.stepErrors = {
          step1: {},
          step2: {},
          step3: {},
        };

        this.formData = {
          step1: {
            dateVisite: "",
            prochaineVisite: "",
            proprietaireId: "",
            animalId: "",
            proprietaireObject: null,
            animalObject: null,
          },
          step2: {
            reference: null,
            poidsIdeal: 0,
            activiteQuotidienne: "",
            stadePhysiologique: "",
            tarifTTC: "",
            adresseClinique: null,
            afficherCout: false,
            rappelJ7: "",
            targetWeightValue: "",
            applicationStartDate: "",
          },
        };
        this.selectedProprietaireId = "";
        this.selectedAnimalId = "";
        this.selectedClinicAddress = "";
        this.isChecked = false;
        this.reminderJ7Types = [];
        this.calculationResults = null;
        this.calculationError = null;
        this.calculationNote = null;
        this.hasVisitedStep2 = false;
        this.step1SnapshotAtStep2 = null;
        this.productsStore.resetRationState();
      },

      /**
       * Génère et télécharge le PDF en utilisant l'adaptateur unifié
       */
      async downloadPDF() {
        try {
          const rawData = {
            ...this.calculationResults,
            animal: this.formData.step1.animalObject,
            owner: this.formData.step1.proprietaireObject,
            dailyExpenses: this.calculationResults?.dailyExpenses,
            showDailyExpenses: this.isChecked, // Checkbox du formulaire
            selectedProduct: this.productsStore.selectedRationProduct,
            selectedVariant: this.productsStore.selectedRationVariant,
            veterinarianAddressIds: this.selectedClinicAddress ? [parseInt(this.selectedClinicAddress)] : null,
            variantImage: this.calculationResults?.variantImage || null,
          };

          await this.jsPdfService.generateRationPdf(rawData, this.pdfFilename);
        } catch (error) {
          console.error("Erreur lors de la génération PDF:", error);
          alert("La génération du PDF a échoué. Veuillez réessayer ou contacter le support.");
        }
      },
      toggleSection(index) {
        this.activeIndex = this.activeIndex === index ? null : index;
      },
      openAddModal() {
        this.resetProprietaireForm();
        this.proprietairesStore.resetState();
      },

      resetProprietaireForm() {
        this.proprietaireForm = {
          firstName: "",
          lastName: "",
          email: "",
          cellphone: "",
          indicatifCellphone: "33",
        };
        this.formErrors = {};
      },

      validateProprietaireForm() {
        this.formErrors = {};
        let isValid = true;

        if (!this.proprietaireForm.lastName.trim()) {
          this.formErrors.lastName = "Le nom est obligatoire";
          isValid = false;
        }

        if (!this.proprietaireForm.firstName.trim()) {
          this.formErrors.firstName = "Le prénom est obligatoire";
          isValid = false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!this.proprietaireForm.email.trim()) {
          this.formErrors.email = "L'email est obligatoire";
          isValid = false;
        } else if (!emailRegex.test(this.proprietaireForm.email)) {
          this.formErrors.email = "Format d'email invalide";
          isValid = false;
        }

        if (this.proprietaireForm.cellphone.trim()) {
          const phoneRegex = /^[0-9+\-\s()]+$/;
          if (!phoneRegex.test(this.proprietaireForm.cellphone)) {
            this.formErrors.cellphone = "Format de téléphone invalide";
            isValid = false;
          }
        }

        return isValid;
      },

      async submitProprietaire() {
        if (!this.validateProprietaireForm()) {
          return;
        }

        try {
          await this.proprietairesStore.addProprietaire(this.proprietaireForm);
          this.closeModal();
        } catch (error) {
          if (error.response?.status === 400) {
            this.formErrors.email = "Cet email existe déjà";
          } else {
            console.error("Erreur lors de l'ajout du propriétaire:", error);
          }
        }
      },

      closeAndResetModal(modalRefName, resetFormFn) {
        const modal = this.$refs[modalRefName];
        if (modal) {
          modal.querySelector('[data-bs-dismiss="modal"]')?.click();
        }
        if (resetFormFn) {
          resetFormFn();
        }
      },

      closeModal() {
        this.closeAndResetModal("ProprietereAddModal", this.resetProprietaireForm);
      },

      async onProprietaireChange() {
        this.selectedAnimalId = "";
        this.resetAnimalEditingMode();

        if (this.selectedProprietaireId) {
          try {
            await this.animauxStore.fetchAnimauxByProprietaire(this.selectedProprietaireId);
          } catch (error) {
            console.error("Erreur lors du chargement des animaux:", error);
          }
        } else {
          this.animauxStore.resetAnimaux();
        }
      },

      openAnimalModal() {
        this.resetAnimalForm();

        if (this.selectedProprietaireId) {
          this.animalForm.proprietaireId = this.selectedProprietaireId;
        }
      },

      resetAnimalForm() {
        this.animalForm = {
          name: "",
          animalTypeId: "",
          raceId: "",
          birthDate: "",
          gender: "",
          proprietaireId: "",
          weight: 0.0,
          underAge: false,
        };
        this.animalFormErrors = {};
        this.filteredRaces = [];
      },

      validateAnimalForm() {
        this.animalFormErrors = {};
        let isValid = true;

        if (!this.animalForm.proprietaireId) {
          this.animalFormErrors.proprietaireId = "Le propriétaire est obligatoire";
          isValid = false;
        }

        if (!this.animalForm.name.trim()) {
          this.animalFormErrors.name = "Le nom est obligatoire";
          isValid = false;
        }

        if (!this.animalForm.animalTypeId) {
          this.animalFormErrors.animalTypeId = "Le type d'animal est obligatoire";
          isValid = false;
        }

        if (!this.animalForm.raceId) {
          this.animalFormErrors.raceId = "La race est obligatoire";
          isValid = false;
        }

        return isValid;
      },

      async submitAnimal() {
        if (!this.validateAnimalForm()) {
          return;
        }

        try {
          const selectedType = this.animauxStore.animalTypes.find(
            type => type.id === parseInt(this.animalForm.animalTypeId)
          );
          const selectedRace = this.filteredRaces.find(race => race.id === parseInt(this.animalForm.raceId));

          const animalData = {
            name: this.animalForm.name.trim(),
            species: selectedType ? selectedType.name : "",
            breed: selectedRace ? selectedRace.name : "",
            birthDate: this.animalForm.birthDate || null,
            weight: this.animalForm.weight.toString(),
            ownerId: parseInt(this.animalForm.proprietaireId),
            animalTypeId: parseInt(this.animalForm.animalTypeId),
            raceId: parseInt(this.animalForm.raceId),
            gender: this.animalForm.gender || null,
            dailyActivityId: this.animalForm.dailyActivityId ? parseInt(this.animalForm.dailyActivityId) : null,
            physiologicalStageId: this.animalForm.physiologicalStageId
              ? parseInt(this.animalForm.physiologicalStageId)
              : null,
            idealWeight: this.animalForm.idealWeight ? this.animalForm.idealWeight.toString() : null,
            underAge: !!this.animalForm.underAge,
          };
          const proprietaireId = this.animalForm.proprietaireId;
          const newAnimal = await this.animauxStore.addAnimal(animalData);
          if (newAnimal && newAnimal.id) {
            this.selectedProprietaireId = proprietaireId;
            this.selectedAnimalId = newAnimal.id.toString();
            await this.animauxStore.fetchAnimauxByProprietaire(proprietaireId);
          }

          this.closeAnimalModal();
        } catch (error) {
          console.error("Erreur lors de l'ajout de l'animal:", error);
          this.animalFormErrors.general = "Erreur lors de l'ajout de l'animal";
        }
      },

      closeAnimalModal() {
        this.closeAndResetModal("AnimalAddModal", this.resetAnimalForm);
      },

      async fetchVeterinaryAddresses() {
        try {
          const response = await getAddresses();
          const allAddresses = response.data || [];
          this.veterinaryAddresses = allAddresses.filter(address => address.veterinary === true);
        } catch (error) {
          console.error("Erreur lors de la récupération des adresses de livraison:", error);
          this.veterinaryAddresses = [];
        }
      },

      toggleProductDropdown() {
        this.showProductDropdown = !this.showProductDropdown;
      },

      selectProduct(product) {
        this.productsStore.selectRationProduct(product);
        this.showProductDropdown = false;
        this.updateReferenceInFormData();
        this.resetFieldsBasedOnProductTags();
      },

      getProductReference() {
        const selectedProduct = this.productsStore.selectedRationProduct;
        const selectedVariant = this.productsStore.selectedRationVariant;

        if (selectedProduct && selectedVariant) {
          const productName = selectedProduct.name || selectedProduct.title || "Produit";
          const variantName = selectedVariant.name || selectedVariant.title || "";
          const weight = selectedVariant.weight || this.calculationResults?.variantWeight || "";

          if (weight) {
            return `${productName} - ${variantName} - ${weight}kg`;
          } else {
            return `${productName} - ${variantName}`;
          }
        }

        if (this.calculationResults) {
          const results = this.calculationResults;
          let productName = "Produit";
          if (results.product) {
            const productPath = results.product.split("/").pop();
            productName = decodeURIComponent(productPath).replace(/%20/g, " ");
          }
          let variantName = "";
          if (results.productVariant) {
            const variantPath = results.productVariant.split("/").pop();
            variantName = decodeURIComponent(variantPath).replace(/%20/g, " ");
          }
          const weight = results.variantWeight || "";
          if (weight && variantName) {
            return `${productName} - ${variantName} - ${weight}kg`;
          } else if (variantName) {
            return `${productName} - ${variantName}`;
          }

          return productName;
        }
        return "Référence produit";
      },

      getDailyActivityLabel(animal) {
        if (!animal?.dailyActivityId) return "Non spécifié";

        const activity = this.animauxStore.dailyActivities.find(act => act.id === animal.dailyActivityId);

        return activity ? activity.name : "Non spécifié";
      },

      getPhysiologicalStageLabel(animal) {
        if (!animal?.physiologicalStageId) return "Non spécifié";

        const stage = this.animauxStore.physiologicalStages.find(st => st.id === animal.physiologicalStageId);

        return stage ? stage.name : "Non spécifié";
      },

      getUnderAgeLabel(animalTypeId) {
        if (!animalTypeId) return "Chiot/Chaton";
        const type = this.animauxStore.animalTypes.find(t => t.id === parseInt(animalTypeId));
        if (!type) return "Chiot/Chaton";
        const slug = String(type.slug || "").toLowerCase();
        const name = String(type.name || "").toLowerCase();
        if (slug === "dog" || name === "chien") return "Chiot";
        if (slug === "cat" || name === "chat") return "Chaton";
        return "Chiot/Chaton";
      },

      resetAnimalEditingMode() {
        this.isEditingAnimal = false;
      },

      formatDateForInput(dateString) {
        if (!dateString) return "";
        return dateString.split(" ")[0];
      },

      openEditAnimalModal() {
        if (!this.selectedAnimalId) return;

        const animal = this.selectedAnimalObject;
        if (!animal) return;

        if (animal.animalTypeId) {
          this.editFilteredRaces = this.animauxStore.getFilteredRaces(animal.animalTypeId);
        }

        this.editAnimalForm = {
          id: animal.id,
          name: animal.name || "",
          animalTypeId: animal.animalTypeId ? animal.animalTypeId.toString() : "",
          raceId: animal.raceId ? animal.raceId.toString() : "",
          birthDate: this.formatDateForInput(animal.birthDate),
          gender: animal.gender || "",
          proprietaireId: animal.ownerId ? animal.ownerId.toString() : this.selectedProprietaireId,
          weight: parseFloat(animal.weight) || 0.0,
          dailyActivityId: animal.dailyActivityId ? animal.dailyActivityId.toString() : "",
          physiologicalStageId: animal.physiologicalStageId ? animal.physiologicalStageId.toString() : "",
          idealWeight: parseFloat(animal.idealWeight) || 0.0,
          underAge: !!animal.underAge,
        };

        this.editAnimalFormErrors = {};
      },

      validateEditAnimalForm() {
        this.editAnimalFormErrors = {};
        let isValid = true;

        if (!this.editAnimalForm.name.trim()) {
          this.editAnimalFormErrors.name = "Le nom est obligatoire";
          isValid = false;
        }

        if (!this.editAnimalForm.animalTypeId) {
          this.editAnimalFormErrors.animalTypeId = "Le type d'animal est obligatoire";
          isValid = false;
        }

        if (!this.editAnimalForm.raceId) {
          this.editAnimalFormErrors.raceId = "La race est obligatoire";
          isValid = false;
        }

        return isValid;
      },

      async submitEditAnimal() {
        if (!this.validateEditAnimalForm()) {
          return;
        }

        try {
          const selectedType = this.animauxStore.animalTypes.find(
            type => type.id === parseInt(this.editAnimalForm.animalTypeId)
          );
          const selectedRace = this.editFilteredRaces.find(race => race.id === parseInt(this.editAnimalForm.raceId));
          const animalData = {
            name: this.editAnimalForm.name.trim(),
            species: selectedType ? selectedType.name : "",
            breed: selectedRace ? selectedRace.name : "",
            birthDate: this.editAnimalForm.birthDate || null,
            weight: this.editAnimalForm.weight.toString(),
            ownerId: parseInt(this.editAnimalForm.proprietaireId),
            animalTypeId: parseInt(this.editAnimalForm.animalTypeId),
            raceId: parseInt(this.editAnimalForm.raceId),
            gender: this.editAnimalForm.gender || null,
            dailyActivityId: this.editAnimalForm.dailyActivityId ? parseInt(this.editAnimalForm.dailyActivityId) : null,
            physiologicalStageId: this.editAnimalForm.physiologicalStageId
              ? parseInt(this.editAnimalForm.physiologicalStageId)
              : null,
            idealWeight: this.editAnimalForm.idealWeight ? this.editAnimalForm.idealWeight.toString() : null,
            underAge: !!this.editAnimalForm.underAge,
          };

          await this.animauxStore.updateAnimal(this.editAnimalForm.id, animalData);
          this.closeEditAnimalModal();
        } catch (error) {
          console.error("Erreur lors de la modification de l'animal:", error);
          this.editAnimalFormErrors.general = "Erreur lors de la modification de l'animal";
        }
      },

      resetEditAnimalForm() {
        this.editAnimalForm = {
          id: null,
          name: "",
          animalTypeId: "",
          raceId: "",
          birthDate: "",
          gender: "",
          proprietaireId: "",
          weight: 0.0,
          underAge: false,
        };
        this.editAnimalFormErrors = {};
        this.editFilteredRaces = [];
      },

      updateWeight(operation, form, field) {
        let value = form[field];
        if (operation === "increment") {
          value = Math.min(value + 0.1, 999.9);
        } else if (operation === "decrement") {
          value = Math.max(value - 0.1, 0);
        }
        form[field] = Math.round(value * 10) / 10;
      },

      getTargetWeight() {
        const animal = this.formData.step1.animalObject;
        if (!animal || !animal.idealWeight) {
          return "Non renseigné";
        }
        return parseFloat(animal.idealWeight).toFixed(1);
      },

      getTargetWeightLabel() {
        const underAge = !!this.formData.step1.animalObject?.underAge;
        return underAge ? "Poids adulte estimé*" : "Poids idéal*";
      },

      getInitialTargetWeightFromAnimal() {
        const animal = this.formData.step1.animalObject;
        if (!animal) return "";
        const underAge = !!animal.underAge;
        const source = underAge ? animal.estimatedAdultWeight || animal.idealWeight : animal.idealWeight;
        if (!source) return "";
        const n = parseFloat(source);
        return isNaN(n) ? "" : n.toFixed(1);
      },

      normalizeWeight(value) {
        if (value === null || value === undefined || value === "") return null;
        const n = parseFloat(value);
        if (isNaN(n) || n <= 0) return null;
        return n.toFixed(1);
      },

      getAnimalDailyActivityName() {
        const animal = this.formData.step1.animalObject;
        if (!animal || !animal.dailyActivityId) {
          return "Non renseigné";
        }
        const activity = this.animauxStore.dailyActivities.find(act => act.id === animal.dailyActivityId);
        return activity ? `${activity.name} (${activity.coefficient})` : "Non trouvé";
      },

      getAnimalPhysiologicalStageName() {
        const animal = this.formData.step1.animalObject;
        if (!animal || !animal.physiologicalStageId) {
          return "Non renseigné";
        }

        const stage = this.animauxStore.physiologicalStages.find(st => st.id === animal.physiologicalStageId);
        return stage ? `${stage.name} (${stage.coefficient})` : "Non trouvé";
      },

      closeEditAnimalModal() {
        this.closeAndResetModal("AnimalEditModal", this.resetEditAnimalForm);
      },

      selectVariant(variantCode) {
        const variant = this.productsStore.availableRationVariants.find(v => v.code === variantCode);
        if (variant) {
          this.productsStore.selectRationVariant(variant);
          this.updateReferenceInFormData();
        }
      },

      /**
       * Réinitialise les champs du formulaire en fonction des tags du produit sélectionné
       */
      resetFieldsBasedOnProductTags() {
        if (this.isPuppyKittenProduct) {
          this.selectedDailyActivityId = "";
          this.selectedPhysiologicalStageId = "";
        }

        if (!this.isObesityProduct) {
          this.selectedWeightManagementId = "";
        }
      },

      updateReferenceInFormData() {
        this.formData.step2.reference = this.productsStore.getRationReferenceObject();
      },

      getStep1Snapshot() {
        return {
          dateVisite: this.formData.step1.dateVisite || "",
          prochaineVisite: this.formData.step1.prochaineVisite || "",
          proprietaireId: this.selectedProprietaireId || "",
          animalId: this.selectedAnimalId || "",
        };
      },

      captureStep1Snapshot() {
        try {
          this.step1SnapshotAtStep2 = JSON.stringify(this.getStep1Snapshot());
        } catch (e) {
          this.step1SnapshotAtStep2 = null;
        }
      },

      maybeResetStep2OnStep1Change() {
        if (this.currentStep === 1 && this.hasVisitedStep2 && this.step1SnapshotAtStep2) {
          const current = JSON.stringify(this.getStep1Snapshot());
          if (current !== this.step1SnapshotAtStep2) {
            this.resetStep2State();
            this.step1SnapshotAtStep2 = current;
          }
        }
      },

      resetStep2State() {
        this.formData.step2 = {
          reference: null,
          poidsIdeal: 0,
          activiteQuotidienne: "",
          stadePhysiologique: "",
          tarifTTC: "",
          adresseClinique: null,
          afficherCout: false,
          rappelJ7: "",
          targetWeightValue: "",
          applicationStartDate: "",
        };
        this.selectedDailyActivityId = "";
        this.selectedPhysiologicalStageId = "";
        this.selectedWeightManagementId = "";
        this.selectedClinicAddress = "";
        this.isChecked = false;
        this.reminderJ7Types = [];
        this.calculationResults = null;
        this.calculationError = null;
        this.calculationNote = null;
        this.stepValidation.step2 = false;
        this.stepErrors.step2 = {};
        if (this.productsStore?.resetRationState) {
          this.productsStore.resetRationState();
        }
      },

      async loadProductsForAnimalType() {
        if (!this.formData.step1.animalObject?.animalTypeId) {
          return;
        }

        try {
          await this.productsStore.fetchProductsByAnimalType(this.formData.step1.animalObject.animalTypeId);
        } catch (error) {
          console.error("Erreur lors du chargement des produits:", error);
        }
      },

      getProductImage(product) {
        if (!product) return null;
        if (product.imagesDetails && product.imagesDetails.length > 0) {
          return product.imagesDetails[0].path;
        }
        if (product.images && product.images.length > 0) {
          return product.images[0].path;
        }
        if (product.variant && product.variant.imagesProduct && product.variant.imagesProduct.length > 0) {
          return product.variant.imagesProduct[0].path;
        }
        if (product.variant && product.variant.imagesDetails && product.variant.imagesDetails.length > 0) {
          return product.variant.imagesDetails[0].path;
        }
        if (product.variant && product.variant.image) {
          return product.variant.image;
        }
        if (product.image) {
          return product.image;
        }

        return null;
      },

      /**
       * Charge les rations groupées par propriétaires depuis l'API
       */
      async loadGroupedRations() {
        try {
          this.listingLoading = true;
          this.listingError = null;
          const response = await calculRationService.getGroupedRationsByOwners(this.form.search);
          this.groupedRations = response;
        } catch (error) {
          console.error("Erreur lors du chargement des rations groupées:", error);
          this.listingError = "Impossible de charger les calculs de ration. Veuillez réessayer.";
        } finally {
          this.listingLoading = false;
        }
      },

      /**
       * Retourne le nom d'affichage d'un propriétaire
       */
      getOwnerDisplayName(owner) {
        if (!owner) return "Propriétaire inconnu";

        const firstName = owner.firstName || "";
        const lastName = owner.lastName || "";

        if (firstName && lastName) {
          return `${firstName} ${lastName}`;
        } else if (firstName) {
          return firstName;
        } else if (lastName) {
          return lastName;
        } else {
          return owner.email || "Propriétaire inconnu";
        }
      },
      /**
       * Gère la suppression d'un propriétaire
       */
      deleteOwner(owner) {
        // TODO: Implémenter la suppression du propriétaire
        if (
          confirm(
            `Êtes-vous sûr de vouloir supprimer le propriétaire ${this.getOwnerDisplayName(owner)} et tous ses calculs de ration ?`
          )
        ) {
          alert("Suppression du propriétaire - Fonctionnalité à implémenter");
        }
      },

      /**
       * Gère l'événement de rappel d'une ration
       */
      handleRationReminder(ration) {
        this.$refs.reminderModal.open(ration);
      },

      /**
       * Callback après la sauvegarde du rappel
       */
      async onReminderSaved() {
        await this.loadGroupedRations();
        alert("Rappel mis à jour avec succès !");
      },

      /**
       * Gère le téléchargement PDF d'une ration depuis le listing
       */
      handleRationDownloadPdf(ration) {
        try {
          let ownerData = null;
          for (const ownerGroup of this.groupedRations.owners) {
            if (ownerGroup.rations.some(r => r.id === ration.id)) {
              ownerData = ownerGroup.owner;
              break;
            }
          }

          const enrichedRation = {
            ...ration,
            owner: ownerData,
            variantImage: ration.variantImage || null,
          };

          const filename = `ration-${ration.animal.name}-${new Date().toISOString().split("T")[0]}.pdf`;

          this.jsPdfService.generateRationPdf(enrichedRation, filename);
        } catch (error) {
          console.error("Erreur lors de la génération PDF:", error);
          alert("Erreur lors de la génération du PDF. Veuillez réessayer.");
        }
      },

      getProductReferenceFromRation(ration) {
        if (ration.product && ration.productVariant) {
          const productName = ration.product.name || "Produit";
          const variantWeight = ration.productVariant.weight || ration.productWeight || "";

          if (variantWeight) {
            return `${productName} - ${variantWeight}kg`;
          }
          return productName;
        }

        return "Référence produit";
      },

      /**
       * Gère l'édition d'une ration
       */
      handleRationEdit(ration) {
        // TODO: Implémenter l'édition de ration
        alert(`Édition de la ration pour ${ration.animal.name} - Fonctionnalité à implémenter`);
      },

      /**
       * Gère la suppression d'une ration
       */
      async handleRationDelete(ration) {
        const animalName = ration.animal.name || "cet animal";
        const productName = this.getProductReferenceFromRation(ration);

        const confirmMessage = `Êtes-vous sûr de vouloir supprimer le calcul de ration pour ${animalName} ?\n\nProduit : ${productName}\nRation journalière : ${Math.round(parseFloat(ration.recommendedDailyAmount || 0))} g`;

        if (!confirm(confirmMessage)) {
          return;
        }

        try {
          this.listingLoading = true;
          await calculRationService.deleteRation(ration.id);
          await this.loadGroupedRations();

          alert(`Le calcul de ration pour ${animalName} a été supprimé avec succès.`);
        } catch (error) {
          console.error("Erreur lors de la suppression de la ration:", error);

          let errorMessage = "Une erreur est survenue lors de la suppression du calcul de ration.";

          if (error.response?.status === 404) {
            errorMessage = "Ce calcul de ration n'existe plus ou a déjà été supprimé.";
          } else if (error.response?.status === 403) {
            errorMessage = "Vous n'avez pas les droits pour supprimer ce calcul de ration.";
          }
          alert(errorMessage);
          await this.loadGroupedRations();
        } finally {
          this.listingLoading = false;
        }
      },
    },
  };
</script>

<style scoped>
  @import "@/assets/css/components/CalculRation.css";
  @import "@/assets/css/components/ProductSelector.css";

  .adaptive-inputs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1rem;
    width: 100%;
  }

  .adaptive-input-item {
    min-width: 0;
  }

  @media (max-width: 768px) {
    .adaptive-inputs-grid {
      grid-template-columns: 1fr;
      gap: 0.75rem;
    }
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    .adaptive-inputs-grid {
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    }
  }

  @media (min-width: 1025px) {
    .adaptive-inputs-grid {
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    }
  }

  .adaptive-input-item {
    transition: all 0.3s ease-in-out;
    opacity: 1;
    transform: scale(1);
  }

  .adaptive-input-item[v-show="false"] {
    opacity: 0;
    transform: scale(0.95);
    pointer-events: none;
  }

  .input-group {
    display: flex;
    width: 100%;
    border: none !important;
  }

  .telephone-select {
    background-color: #e9ecef;
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-color: #ced4da;
    max-width: 140px;
  }

  .telephone-select:focus {
    z-index: 2;
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }

  .telephone-input {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-color: #ced4da;
  }

  .telephone-input:focus {
    z-index: 2;
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }

  /* Ensure the border between them looks seamless or handled correctly */
  .telephone-select:not(:focus) + .telephone-input:not(:focus) {
    border-left: 1px solid #ced4da;
  }

  .form-select {
    color: #212529 !important;
    border: 1px solid #36373987 !important;
    border-radius: 35px 0 0 35px !important;
  }
</style>
